import React, { ReactNode, useMemo } from "react";

import { type Money, formatMoneyCompact } from "@performyard/money";
import { Spinner, Text } from "@performyard/py-components";

export const CompensationInfoWidget = ({
	title,
	counter,
	description,
	isLoading = false,
	testId = "widget",
}: {
	title: ReactNode;
	counter: Money;
	description: string[];
	isLoading?: boolean;
	testId?: string;
}) => {
	// `formatMoneyCompact` replaces a hand-rolled abbreviator that divided by 1000 in a
	// loop and hardcoded a "$" at the render site. Same output, one implementation, and
	// the currency symbol comes from `Intl` rather than from a string literal.
	const counterDisplay = useMemo(() => formatMoneyCompact(counter), [counter]);

	return (
		<div
			data-testid={testId}
			className="flex max-h-[112px] flex-1 flex-col rounded-md border border-solid border-neutral-2 p-4"
		>
			<div className="flex gap-1">
				<Text size="paragraph-3" weight="regular" color="neutral-5">
					{title}
				</Text>
			</div>
			{isLoading ? (
				<div className="flex h-[48px] w-full items-center justify-around">
					<Spinner size={32} />
					<span />
					<span />
				</div>
			) : (
				<>
					<Text size="heading-2" weight="semi-bold">
						{counterDisplay}
					</Text>
					<Text size="caption" weight="regular" color="neutral-5">
						{description.join(" ")}
					</Text>
				</>
			)}
		</div>
	);
};
